import {
    AllEvents,
    EntitledToView,
    ImageSourceWithCaptions,
    PublicationType,
    RequiredAccess,
} from '@news-mono/web-common'
import { Logger } from '@west-australian-newspapers/typescript-log'
import H from 'history'
import React, { Fragment } from 'react'
import { LazyBreachWallContentWrapper } from './components/BreachWallContentWrapper/BreachWallContentWrapper.lazy'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import {
    StyledGalleryBreach,
    StyledGalleryBreachNotification,
} from './GalleryBreach.styled'

interface GalleryProps {
    requiredAccess: RequiredAccess
    location: H.Location
    images: ImageSourceWithCaptions[]
    onEvent: (event: AllEvents) => void
    children: (
        content: {
            images: ImageSourceWithCaptions[]
        },
        entitled: boolean,
    ) => React.ReactElement<any>
    gallery: PublicationType
    slug: string
    log: Logger
}

export const GalleryBreach: React.FC<GalleryProps> = (props) => {
    const {
        requiredAccess,
        location,
        images,
        onEvent,
        children,
        gallery,
        slug,
        log,
    } = props
    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                location,
                onEvent,
                gallery,
            )}
            entitled={() => {
                return children({ images }, true)
            }}
            notEntitled={() => {
                const { children } = props
                return (
                    <Fragment>
                        <StyledGalleryBreach>
                            {children({ images: [] }, false)}
                        </StyledGalleryBreach>
                        <StyledGalleryBreachNotification>
                            <LazyBreachWallContentWrapper
                                publication={gallery}
                                requiredAccess={requiredAccess.level}
                                location={location}
                                onEvent={onEvent}
                                log={log}
                            />
                        </StyledGalleryBreachNotification>
                    </Fragment>
                )
            }}
        />
    )
}

GalleryBreach.displayName = 'GalleryBreach'
